module.exports = require("@material-ui/core/TableCell");